import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss'],
    standalone: true
})
export class PricingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
